module.exports = __webpack_public_path__ + "media/search.709950eb.svg";